export default __webpack_public_path__ + "static/media/kananda-ferreira.934f9b58.ogg";